import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.components.ActionsMenuFragments.components.purgeOrder.title',
    defaultMessage: 'Purge order',
  }
})
